<template>
  <div id="projects" class="relative bg-white dark:bg-gray-800 p-8 rounded-2xl shadow-lg border dark:border-gray-900">
    <!-- Section Title with Gradient Underline -->
    <h2 class="text-3xl font-bold text-gray-900 dark:text-gray-100 relative inline-block mb-6">
      Projects
      <span class="absolute left-0 bottom-0 w-full h-1 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full"></span>
    </h2>

    <ul class="space-y-8">
      <li v-for="(project, index) in projects" :key="index" class="p-6 rounded-lg shadow-md dark:bg-gray-900 bg-gray-100 border dark:border-gray-700">
        <!-- Project Name & Link -->
        <div class="flex justify-between items-center mb-3">
          <h3 class="text-2xl font-semibold text-gray-800 dark:text-gray-100">{{ project.name }}</h3>
          <a :href="project.link" target="_blank" class="text-blue-500 hover:underline flex items-center gap-1">
            Visit <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M12.293 3.293a1 1 0 011.414 0l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414-1.414L15.586 10H4a1 1 0 110-2h11.586l-3.293-3.293a1 1 0 010-1.414z" clip-rule="evenodd" /></svg>
          </a>
        </div>

        <!-- Overview -->
        <h6 class="text-lg font-medium text-gray-700 dark:text-gray-300 mb-1">Overview</h6>
        <p class="text-gray-600 dark:text-gray-300 text-justify">{{ project.description }}</p>

        <!-- Description List (if any) -->
        <ul v-if="project.descriptionList" class="list-disc ml-6 mt-2">
          <li v-for="(desc, key) in project.descriptionList" :key="key" class="text-gray-600 dark:text-gray-300">
            <span class="font-semibold">{{ key }}:</span> {{ desc }}
          </li>
        </ul>

        <!-- My Role -->
        <h6 class="text-lg font-medium text-gray-700 dark:text-gray-300 mt-3">My Role</h6>
        <p class="text-gray-600 dark:text-gray-300">{{ project.myRole }}</p>

        <!-- Tech Stack -->
        <h6 class="text-lg font-medium text-gray-700 dark:text-gray-300 mt-3">Tech Stack</h6>
        <ul class="flex flex-wrap gap-2 mt-2">
          <li v-for="(stackName, index) in project.techStack" :key="index"
              class="px-3 py-1 rounded-full text-sm font-semibold bg-gray-300 text-gray-800 dark:bg-gray-700 dark:text-gray-200 shadow-sm">
            {{ stackName }}
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>


<script>
export default {
  name: 'ProjectsSection',
  data() {
    return {
      projects: [
        {
          name: "Enginehire",
          description: "The truly all-in-one staffing software, designed to streamline your entire process from start to finish. Stop paying for 5 different tools, manage your client & candidate recruitment & onboarding, staff scheduling, billing, payroll & more. Every single thing is customizable, so you don’t fit your process to the software, the software fits your process. Enginehire is for you if your company is serious about growing, saving time & improving efficiency.",
          techStack: [
            "Django",
            "Vue",
            "Vuex",
            "Python",
            "Postgres",
            "AWS S3",
            "AWS SES",
            "AWS Pipelines",
            "Twilio",
            "Bugsnag",
            "Redis"
          ],
          myRole: "Full Stack Engineer in a team",
          link: "https://enginehire.io/"
        },
        {
          name: 'Shopexperts',
          description: 'A freelancing platform for Shopify developers, featuring three distinct portals: Admin, Client, and Expert.',
          descriptionList: {
            Clients: "Can post projects and questions.",
            Experts: "Can select projects and work through various phases until completion.",
            Admins: "Approve clients, experts, and projects, and can view all platform statistics etc."
          },
          myRole: "Solo Full Stack Engineer",
          techStack: [
            "Laravel",
            "Vue.js",
            "DigitalOcean",
            "AWS S3",
            "Stripe",
            "Postmark",
            "Web sockets",
            "Cloudflare"
          ],
          link: "https://shopexperts.com/"
        },
        {
          name: 'Compare24',
          description: "A platform for stress-free home improvement solutions. Connect homeowners with top-rated professionals and provide free, no-obligation quotes to help them get started on their new projects.",
          myRole: "Solo Full Stack Engineer",
          techStack: [
            "Svelte",
            "Backend - Firebase functions",
            "DB - Firebase",
          ],
          link: "https://compare24.net/"
        },
        {
          name: 'QRazy',
          description: 'This is a small application that allows users to manage and play videos stored on Amazon S3. Users can upload videos, create different URLs, and associate uploaded videos with those URLs. The unique feature of this application is that users can add or remove different videos using a single URL, and the URL will play the video without any changes.',
          descriptionList: {
            "Upload Videos": "Users can upload videos to Amazon S3.",
            "Delete Videos": "Users can delete uploaded videos from Amazon S3.",
            "Create or Edit URLs": "Users can create new URLs or edit existing ones and attach uploaded videos to them.",
            "Delete URL Mappings": "Users can delete URL mappings, dissociating videos from URLs.",
            "Play Videos": "URLs generated by the application can be used to play videos.",
          },
          myRole: "Solo Full Stack Engineer",
          techStack: [
            "Core PHP",
            "Bootstrap",
            "Mysql",
            "AWS S3 (for file uploads)",
            "AWS Lambda",
            "AWS Route53",
            "AWS EC2",
            "AWS Cloudfront",
            "AWS ACM",
          ],
          link: "https://qrazyland.com/"
        },
        {
          name: 'Baddad',
          description: 'The platform is an e-commerce website for purchasing high-quality motorcycle parts and motorcycles.',
          myRole: "Integrated Mailchimp in the website to manage and execute email campaigns",
          techStack: [
            "Core Php",
            "Bootstrap",
            "Mysql",
            "Mailchimp"
          ],
          link: "https://www.baddad.com/"
        },
      ],
    };
  },
};
</script>
